import Image from '@atlaskit/image';
import badgeAnatomyLight from "../../../../../../packages/design-system/badge/constellation/index/images/badge-anatomy-light.png";
import badgeAnatomyDark from "../../../../../../packages/design-system/badge/constellation/index/images/badge-anatomy-dark.png";
import badgeColorLight from "../../../../../../packages/design-system/badge/constellation/index/images/badge-color-light.png";
import badgeColorDark from "../../../../../../packages/design-system/badge/constellation/index/images/badge-color-dark.png";
import badgeDo1Light from "../../../../../../packages/design-system/badge/constellation/index/images/badge-do-1-light.png";
import badgeDo1Dark from "../../../../../../packages/design-system/badge/constellation/index/images/badge-do-1-dark.png";
import badgeDont1Light from "../../../../../../packages/design-system/badge/constellation/index/images/badge-dont-1-light.png";
import badgeDont1Dark from "../../../../../../packages/design-system/badge/constellation/index/images/badge-dont-1-dark.png";
import badgeDo2Light from "../../../../../../packages/design-system/badge/constellation/index/images/badge-do-2-light.png";
import badgeDo2Dark from "../../../../../../packages/design-system/badge/constellation/index/images/badge-do-2-dark.png";
import badgeDont2Light from "../../../../../../packages/design-system/badge/constellation/index/images/badge-dont-2-light.png";
import badgeDont2Dark from "../../../../../../packages/design-system/badge/constellation/index/images/badge-dont-2-dark.png";
import badgeDo2BoldLight from "../../../../../../packages/design-system/badge/constellation/index/images/badge-do-2-bold-light.png";
import badgeDo2BoldDark from "../../../../../../packages/design-system/badge/constellation/index/images/badge-do-2-bold-dark.png";
import badgeDont2BoldLight from "../../../../../../packages/design-system/badge/constellation/index/images/badge-dont-2-bold-light.png";
import badgeDont2BoldDark from "../../../../../../packages/design-system/badge/constellation/index/images/badge-dont-2-bold-dark.png";
import * as React from 'react';
export default {
  Image,
  badgeAnatomyLight,
  badgeAnatomyDark,
  badgeColorLight,
  badgeColorDark,
  badgeDo1Light,
  badgeDo1Dark,
  badgeDont1Light,
  badgeDont1Dark,
  badgeDo2Light,
  badgeDo2Dark,
  badgeDont2Light,
  badgeDont2Dark,
  badgeDo2BoldLight,
  badgeDo2BoldDark,
  badgeDont2BoldLight,
  badgeDont2BoldDark,
  React
};